// Bilingual UI strings for DevTask. Keys are dotted paths, resolved by t() in useI18n.
export const messages = {
  he: {
    common: {
      save: 'שמירה', saveChanges: 'שמירת שינויים', create: 'יצירה', cancel: 'ביטול',
      saving: 'שומר…', edit: 'עריכה', reset: 'איפוס', search: 'חיפוש…',
      all: 'הכל', none: '— ללא —', viewAll: 'הצג הכל', loading: 'טוען…',
      from: 'מתאריך', to: 'עד תאריך', export: 'ייצוא CSV',
    },
    search: {
      title: 'תוצאות חיפוש', for: 'עבור', tasks: 'משימות', projects: 'פרויקטים',
      clients: 'לקוחות', noResults: 'לא נמצאו תוצאות עבור', empty: 'הקלד מונח לחיפוש.',
    },
    nav: {
      dashboard: 'לוח בקרה', myTasks: 'המשימות שלי', teamTasks: 'משימות צוות',
      projects: 'פרויקטים', team: 'הצוות', archive: 'ארכיון', clients: 'לקוחות', signOut: 'התנתקות',
      requests: 'בקשות', reports: 'דוחות',
      language: 'English', theme: 'מצב תצוגה', collapse: 'כווץ תפריט',
    },
    portal: {
      navOverview: 'סקירה', navProjects: 'הפרויקטים שלי', navRequests: 'בקשות', navReports: 'דוחות וחיוב',
      dashSub: 'מבט על הפרויקטים, ההתקדמות והחיוב שלך',
      requestWork: 'בקשת עבודה', activeProjects: 'פרויקטים פעילים', openRequests: 'בקשות פתוחות',
      hoursTracked: 'שעות שנמדדו', estBilling: 'חיוב משוער', yourProjects: 'הפרויקטים שלך',
      noProjects: 'אין עדיין פרויקטים.', openTasks: 'משימות פתוחות', noPricing: 'ללא תמחור',
      billingModel: 'מודל חיוב', tasks: 'משימות', noTasks: 'אין עדיין משימות בפרויקט.',
    },
    requests: {
      pending: 'ממתין', approved: 'אושר', declined: 'נדחה',
      typeProject: 'פרויקט חדש', typeTask: 'משימה',
      myTitle: 'הבקשות שלי', mySub: 'בקש פרויקט או משימה חדשה מהצוות',
      newBtn: 'בקשה חדשה', fieldTitle: 'כותרת', titlePh: 'מה תרצה?', fieldDesc: 'פירוט',
      descPh: 'תאר את הבקשה…', fieldProject: 'פרויקט', selectProject: '— בחר פרויקט —',
      billingPref: 'העדפת חיוב', amount: 'סכום מבוקש', submit: 'שלח בקשה',
      empty: 'עדיין לא שלחת בקשות.',
      inboxTitle: 'בקשות לקוחות', inboxSub: 'אשר, ערוך או דחה בקשות עבודה מלקוחות',
      inboxEmpty: 'אין בקשות.', from: 'מאת', billingWanted: 'חיוב מבוקש', reviewed: 'טופלו',
      approve: 'אשר', decline: 'דחה', declineConfirm: 'לדחות את הבקשה "{title}"?',
      deadline: 'יעד', revised: 'הוצעו שינויים',
      revise: 'הצע שינויים', reviseTitle: 'עריכת הבקשה', sendRevision: 'שלח ללקוח',
      awaitingClient: 'ממתין ללקוח', revisedSent: 'נשלחה הצעה ללקוח',
      teamRevised: 'הצוות הציע שינויים לבקשה. ניתן לאשר או להציע משהו אחר.',
      counter: 'הצע משהו אחר', acceptRevision: 'אשר', sendCounter: 'שלח בקשה מעודכנת',
    },
    reports: {
      sub: 'שעות, התקדמות וחיוב לפי פרויקט', allProjects: 'כל הפרויקטים',
      tasksDone: 'משימות שהושלמו', subtasksDone: 'תת-משימות שהושלמו', totalDue: 'סך לתשלום',
      hoursPerTask: 'שעות לפי משימה', subtasksChart: 'התקדמות תת-משימות', billingPerProject: 'חיוב לפי פרויקט',
      done: 'הושלמו', remaining: 'נותרו', noData: 'אין נתונים עדיין.',
    },
    activity: { title: 'פעילות צוות', idle: 'לא פעיל', none: 'אין מפתחים' },
    roles: { client: 'לקוח', manager: 'מנהל', developer: 'מפתח' },
    login: {
      title: 'התחברות למרחב העבודה',
      sub: 'אין לך חשבון? פנה למנהל כדי לקבל גישה.',
      identifier: 'אימייל או שם משתמש',
      identifierPlaceholder: 'you@company.com או שם המשתמש שלך',
      password: 'סיסמה',
      signIn: 'התחברות',
      signingIn: 'מתחבר…',
      failed: 'משהו השתבש בהתחברות. נסו שוב בעוד רגע.',
      invalidCreds: 'האימייל או הסיסמה אינם נכונים. בדקו אותם ונסו שוב.',
      locked: 'יותר מדי ניסיונות התחברות. המתינו כ-15 דקות ונסו שוב.',
      network: 'לא הצלחנו להגיע לשרת. בדקו את חיבור האינטרנט ונסו שוב.',
    },
    dashboard: {
      morning: 'בוקר טוב', afternoon: 'צהריים טובים', evening: 'ערב טוב',
      there: 'שלום',
      sub: 'הנה מה שעל הפרק היום',
      newTask: 'משימה חדשה',
      open: 'פתוחות', inProgress: 'בתהליך', done: 'הושלמו', critical: 'דחופות',
      recentTasks: 'משימות אחרונות',
      empty: 'אין משימות עדיין. צור את הראשונה!',
      projects: 'פרויקטים', myTasks: 'המשימות שלי',
      noProjects: 'אין פרויקטים עדיין.',
      subtasksWidget: 'תת-משימות', commentsWidget: 'תגובות אחרונות',
      noSubtasks: 'אין תת-משימות עדיין.', noComments: 'אין תגובות עדיין.', noRequests: 'אין בקשות ממתינות.',
      dragHint: 'גרור כדי לסדר מחדש את הווידג׳טים', addWidget: 'הוסף ווידג׳ט', hideWidget: 'הסתר ווידג׳ט',
      noWidgets: 'כל הווידג׳טים מוסתרים. הוסף אחד מלמעלה.',
      paneEmpty: 'אין משימות להצגה.',
      progress: 'התקדמות', allDone: 'הכל הושלם',
      newInProject: 'משימה בפרויקט', selectHint: 'בחר פרויקט כדי לראות את המשימות שלו',
    },
    tasks: {
      myTitle: 'המשימות שלי', teamTitle: 'משימות צוות',
      mySub: 'משימות שהוקצו לך או שיצרת', teamSub: 'כל המשימות הגלויות לצוות שלך',
      newTask: 'משימה חדשה',
      allUrgency: 'כל הדחיפויות', allProjects: 'כל הפרויקטים',
      empty: 'לא נמצאו משימות.',
      archiveConfirm: 'להעביר את "{title}" לארכיון?',
      allTasks: 'כל המשימות', restore: 'שחזר',
      restoreConfirm: 'לשחזר את "{title}"?',
      noProjectGroup: 'ללא פרויקט',
      completeArchives: 'סיום מעביר את המשימה לארכיון',
    },
    drawer: {
      details: 'פרטי משימה', close: 'סגירה', save: 'שמירה', saving: 'שומר…',
      created: 'נוצרה', creator: 'נוצר ע״י',
      tabDetails: 'פרטים', tabActivity: 'משנה ותגובות', tabTime: 'יומן זמן',
    },
    sessions: {
      title: 'יומן זמן', date: 'תאריך', minutes: 'דקות', add: 'הוסף רישום',
      empty: 'אין רישומי זמן עדיין.', running: 'פועל', manual: 'ידני', timer: 'טיימר',
      total: 'סך הכל', deleteConfirm: 'למחוק רישום זמן זה?',
    },
    teamReports: {
      title: 'דוחות', sub: 'שעות וחיוב לפי לקוח',
      client: 'לקוח', selectClient: '— בחר לקוח —', teamMember: 'חבר צוות', allMembers: 'כל הצוות',
      allProjects: 'כל הפרויקטים', ticketId: 'מזהה', subject: 'נושא', dateCol: 'תאריך',
      timeCol: 'זמן', costCol: 'עלות', projectCol: 'פרויקט', hoursCol: 'שעות',
      workInPeriod: 'עבודה בתקופה', totalDue: 'סך לתשלום', print: 'הדפס / PDF',
      noClient: 'בחר לקוח כדי להציג דוח.', noData: 'אין נתונים לתקופה זו.',
      reportTitle: 'דו״ח שעות', period: 'תקופה', generated: 'הופק בתאריך',
    },
    taskForm: {
      newTask: 'משימה חדשה', editTask: 'עריכת משימה',
      title: 'כותרת', titlePlaceholder: 'כותרת המשימה',
      description: 'תיאור', descriptionPlaceholder: 'פרטים נוספים…',
      urgency: 'דחיפות', status: 'סטטוס', project: 'פרויקט', dueDate: 'תאריך יעד',
      visibility: 'נראות',
      shared: '🌐 משותף (הצוות רואה)', private: '🔒 פרטי (רק אתה + המוקצה)',
      assignTo: 'הקצה ל', unassigned: '— לא מוקצה —',
      linkClient: 'קישור ללקוח',
      privateProjectLock: 'משימות בפרויקט פרטי הן תמיד פרטיות וגלויות רק לחברי הפרויקט',
      createTask: 'צור משימה', saveFailed: 'השמירה נכשלה',
    },
    taskCard: { private: 'פרטי', markDone: 'סמן כהושלם', finish: 'סיום משימה', reopen: 'פתח מחדש', archive: 'ארכיון' },
    subtasks: {
      toggle: 'תת-משימות', titleCol: 'תת-משימה', titlePlaceholder: 'שם תת-המשימה',
      col: 'עמודה', addColumn: 'הוסף עמודה', removeColumn: 'מחק עמודה', newColumn: 'עמודה חדשה',
      removeColumnConfirm: 'למחוק את העמודה "{label}"?',
      addRow: 'הוסף', removeRow: 'מחק', addPlaceholder: 'תת-משימה חדשה…', empty: 'אין עדיין תת-משימות',
    },
    fields: {
      manage: 'ניהול שדות', addField: 'הוסף שדה', newField: 'צור שדה חדש',
      name: 'שם השדה', namePlaceholder: 'שם השדה', type: 'סוג שדה',
      typeText: 'טקסט', typeNumber: 'מספר', typeDate: 'תאריך', typeSelect: 'בחירה',
      options: 'ערכים', addValue: 'הוסף ערך חדש', addValueShort: 'הוסף',
      scopeThis: 'הוסף לפרויקט זה', scopeAll: 'הוסף לכל הפרויקטים',
      globalBadge: 'כללי', existing: 'שדות קיימים', empty: 'אין שדות עדיין',
      create: 'צור שדה חדש', remove: 'מחק שדה', removeConfirm: 'למחוק את השדה "{label}"?',
      pickValue: '— בחר —',
    },
    comments: {
      title: 'תגובות', empty: 'אין תגובות עדיין',
      placeholder: 'כתוב תגובה…', send: 'שלח', closed: 'המשימה הושלמה — לא ניתן להוסיף תגובות.',
    },
    export: {
      task: 'משימה', project: 'פרויקט', assignee: 'אחראי',
      status: 'סטטוס', urgency: 'דחיפות', hours: 'שעות', due: 'תאריך יעד',
    },
    timer: { start: 'הפעל טיימר', stop: 'עצור טיימר', running: 'פועל כעת' },
    toast: {
      saved: 'השינויים נשמרו',
      taskCreated: 'המשימה נוצרה',
      saveFailed: 'לא הצלחנו לשמור. בדקו את החיבור לאינטרנט ונסו שוב.',
      actionFailed: 'הפעולה לא הושלמה. נסו שוב בעוד רגע.',
      taskCompleted: 'המשימה הושלמה והועברה לארכיון',
      taskRestored: 'המשימה שוחזרה לרשימה הפעילה',
      taskReopened: 'המשימה נפתחה מחדש',
      assigned: 'המשימה הוקצתה ל{name}',
      unassigned: 'הוסרה הקצאת המשימה',
      projectSaved: 'הפרויקט נשמר',
      projectArchived: 'הפרויקט הועבר לארכיון',
      projectRestored: 'הפרויקט שוחזר',
    },
    urgency: { low: 'נמוכה', normal: 'רגילה', high: 'גבוהה', critical: 'דחופה' },
    status: { open: 'פתוחה', in_progress: 'בתהליך', done: 'הושלמה' },
    projects: {
      title: 'פרויקטים', newProject: 'פרויקט חדש', editProject: 'עריכת פרויקט',
      empty: 'אין פרויקטים עדיין.',
      name: 'שם', description: 'תיאור', color: 'צבע', visibility: 'נראות',
      shared: 'משותף (הצוות רואה)', private: 'פרטי (רק אתה)',
      sharedBadge: 'משותף', privateBadge: 'פרטי',
      taskCountOne: 'משימה פתוחה אחת', taskCountMany: 'משימות פתוחות',
      noTasks: 'אין משימות בפרויקט', dragHint: 'גרור כדי לסדר או להעביר בין פרויקטים',
      viewTasks: 'הצג משימות', archiveTitle: 'העבר פרויקט לארכיון',
      archiveConfirm: 'להעביר את הפרויקט "{name}" לארכיון?',
      members: 'חברי הפרויקט', addMember: 'הוסף', remove: 'הסר',
      noMembers: 'אין חברים עדיין', selectUser: '— בחר משתמש —',
      membersHint: 'חברים יכולים לראות את הפרויקט וליצור בו משימות',
      saveFirst: 'שמור את הפרויקט תחילה כדי להוסיף חברים',
      pricing: 'תמחור', pricingNone: 'ללא תמחור', pricingFixed: 'מחיר קבוע', pricingHourly: 'לפי שעה',
      ratePlaceholder: 'תעריף לשעה', totalPlaceholder: 'מחיר כולל',
      clients: 'לקוחות הפרויקט', clientsHint: 'לקוחות שהוקצו רואים את המשימות והשעות של הפרויקט',
      noClients: 'לא הוקצו לקוחות', selectClient: '— בחר לקוח —', addClientBtn: 'הוסף',
    },
    archive: {
      title: 'ארכיון', sub: 'פרויקטים בארכיון — משימות שהושלמו נמצאות תחת מסנן "כל המשימות" בכל פרויקט',
      tasks: 'משימות', projects: 'פרויקטים',
      noTasks: 'אין משימות בארכיון.', noProjects: 'אין פרויקטים בארכיון.',
      archivedOn: 'הועבר לארכיון',
      restore: 'שחזור', restoreConfirm: 'לשחזר את "{title}" מהארכיון?',
    },
    teamPage: {
      title: 'הצוות', sub: 'המפתחים והפרויקטים המשותפים בארגון',
      developers: 'מפתחים', projects: 'פרויקטים משותפים',
      noProjects: 'אין פרויקטים משותפים', tasksCount: 'משימות פתוחות',
    },
    clients: {
      title: 'לקוחות', sub: 'לקוחות חיצוניים שיכולים לצפות במשימות ששותפו איתם',
      addClient: 'הוסף לקוח', editClient: 'עריכת לקוח',
      name: 'שם', username: 'שם משתמש', status: 'סטטוס', projects: 'פרויקטים',
      searchPh: 'חיפוש לפי שם או פרויקט…',
      active: 'פעיל', inactive: 'לא פעיל',
      activate: 'הפעל', deactivate: 'השבת',
      empty: 'אין לקוחות חיצוניים עדיין.',
      fullName: 'שם מלא', usernamePlaceholder: 'ללא רווחים, משמש להתחברות',
      newPassword: 'סיסמה חדשה (השאר ריק לשמירה)', passwordLabel: 'סיסמה',
      passwordPlaceholder: 'לפחות 8 תווים',
      toggleConfirm: '{verb} את {name}?',
    },
  },
  en: {
    common: {
      save: 'Save', saveChanges: 'Save changes', create: 'Create', cancel: 'Cancel',
      saving: 'Saving…', edit: 'Edit', reset: 'Reset', search: 'Search…',
      all: 'All', none: '— None —', viewAll: 'View all', loading: 'Loading…',
      from: 'From', to: 'To', export: 'Export CSV',
    },
    search: {
      title: 'Search results', for: 'for', tasks: 'Tasks', projects: 'Projects',
      clients: 'Clients', noResults: 'No results for', empty: 'Type a term to search.',
    },
    nav: {
      dashboard: 'Dashboard', myTasks: 'My Tasks', teamTasks: 'Team Tasks',
      projects: 'Projects', team: 'Team', archive: 'Archive', clients: 'Clients', signOut: 'Sign out',
      requests: 'Requests', reports: 'Reports',
      language: 'עברית', theme: 'Theme', collapse: 'Collapse menu',
    },
    portal: {
      navOverview: 'Overview', navProjects: 'My Projects', navRequests: 'Requests', navReports: 'Reports & Billing',
      dashSub: 'A look at your projects, progress and billing',
      requestWork: 'Request work', activeProjects: 'Active projects', openRequests: 'Open requests',
      hoursTracked: 'Hours tracked', estBilling: 'Estimated billing', yourProjects: 'Your projects',
      noProjects: 'No projects yet.', openTasks: 'open tasks', noPricing: 'No pricing',
      billingModel: 'Billing model', tasks: 'Tasks', noTasks: 'No tasks in this project yet.',
    },
    requests: {
      pending: 'Pending', approved: 'Approved', declined: 'Declined',
      typeProject: 'New project', typeTask: 'Task',
      myTitle: 'My Requests', mySub: 'Ask the team for a new project or task',
      newBtn: 'New request', fieldTitle: 'Title', titlePh: 'What do you need?', fieldDesc: 'Details',
      descPh: 'Describe your request…', fieldProject: 'Project', selectProject: '— Select project —',
      billingPref: 'Billing preference', amount: 'Proposed amount', submit: 'Submit request',
      empty: "You haven't submitted any requests yet.",
      inboxTitle: 'Client Requests', inboxSub: 'Approve, edit or decline client work requests',
      inboxEmpty: 'No requests.', from: 'from', billingWanted: 'Requested billing', reviewed: 'Reviewed',
      approve: 'Approve', decline: 'Decline', declineConfirm: 'Decline the request “{title}”?',
      deadline: 'Deadline', revised: 'Changes proposed',
      revise: 'Propose changes', reviseTitle: 'Edit request', sendRevision: 'Send to client',
      awaitingClient: 'Awaiting client', revisedSent: 'Revision sent to client',
      teamRevised: 'The team proposed changes to your request. Accept them, or ask for something else.',
      counter: 'Ask for changes', acceptRevision: 'Accept', sendCounter: 'Send updated request',
    },
    reports: {
      sub: 'Hours, progress and billing by project', allProjects: 'All projects',
      tasksDone: 'Tasks done', subtasksDone: 'Subtasks done', totalDue: 'Total due',
      hoursPerTask: 'Hours per task', subtasksChart: 'Subtask progress', billingPerProject: 'Billing per project',
      done: 'Done', remaining: 'Remaining', noData: 'No data yet.',
    },
    activity: { title: 'Team activity', idle: 'Idle', none: 'No developers' },
    roles: { client: 'Client', manager: 'Manager', developer: 'Developer' },
    login: {
      title: 'Sign in to your workspace',
      sub: 'No account? Contact your manager to get access.',
      identifier: 'Email or username',
      identifierPlaceholder: 'you@company.com or your.username',
      password: 'Password',
      signIn: 'Sign in',
      signingIn: 'Signing in…',
      failed: 'Something went wrong signing in. Please try again in a moment.',
      invalidCreds: "That email or password isn't right. Double-check them and try again.",
      locked: 'Too many sign-in attempts. Please wait about 15 minutes and try again.',
      network: "We couldn't reach the server. Check your internet connection and try again.",
    },
    dashboard: {
      morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening',
      there: 'there',
      sub: "Here's what's on your plate today",
      newTask: 'New Task',
      open: 'Open', inProgress: 'In Progress', done: 'Done', critical: 'Critical',
      recentTasks: 'Recent Tasks',
      empty: 'No tasks yet. Create your first one!',
      projects: 'Projects', myTasks: 'My Tasks',
      noProjects: 'No projects yet.',
      subtasksWidget: 'Subtasks', commentsWidget: 'Recent Comments',
      noSubtasks: 'No subtasks yet.', noComments: 'No comments yet.', noRequests: 'No pending requests.',
      dragHint: 'Drag to rearrange widgets', addWidget: 'Add widget', hideWidget: 'Hide widget',
      noWidgets: 'All widgets hidden. Add one above.',
      paneEmpty: 'No tasks to show.',
      progress: 'Progress', allDone: 'All done',
      newInProject: 'New in project', selectHint: 'Pick a project to see its tasks',
    },
    tasks: {
      myTitle: 'My Tasks', teamTitle: 'Team Tasks',
      mySub: 'Tasks assigned to or created by you', teamSub: 'All tasks visible to your team',
      newTask: 'New Task',
      allUrgency: 'All urgency', allProjects: 'All projects',
      empty: 'No tasks found.',
      archiveConfirm: 'Archive "{title}"? It will move to the archive.',
      allTasks: 'All tasks', restore: 'Restore',
      restoreConfirm: 'Restore "{title}"?',
      noProjectGroup: 'No project',
      completeArchives: 'Completing archives the task',
    },
    drawer: {
      details: 'Task details', close: 'Close', save: 'Save', saving: 'Saving…',
      created: 'Created', creator: 'Created by',
      tabDetails: 'Details', tabActivity: 'Subtasks & comments', tabTime: 'Time log',
    },
    sessions: {
      title: 'Time log', date: 'Date', minutes: 'Minutes', add: 'Add entry',
      empty: 'No time logged yet.', running: 'Running', manual: 'Manual', timer: 'Timer',
      total: 'Total', deleteConfirm: 'Delete this time entry?',
    },
    teamReports: {
      title: 'Reports', sub: 'Hours and billing by client',
      client: 'Client', selectClient: '— Select client —', teamMember: 'Team member', allMembers: 'All team',
      allProjects: 'All projects', ticketId: 'ID', subject: 'Subject', dateCol: 'Date',
      timeCol: 'Time', costCol: 'Cost', projectCol: 'Project', hoursCol: 'Hours',
      workInPeriod: 'Work in period', totalDue: 'Total due', print: 'Print / PDF',
      noClient: 'Select a client to view a report.', noData: 'No data for this period.',
      reportTitle: 'Hours report', period: 'Period', generated: 'Generated on',
    },
    taskForm: {
      newTask: 'New Task', editTask: 'Edit Task',
      title: 'Title', titlePlaceholder: 'Task title',
      description: 'Description', descriptionPlaceholder: 'Optional details…',
      urgency: 'Urgency', status: 'Status', project: 'Project', dueDate: 'Due date',
      visibility: 'Visibility',
      shared: '🌐 Shared (team sees this)', private: '🔒 Private (only you + assignee)',
      assignTo: 'Assign to', unassigned: '— Unassigned —',
      linkClient: 'Link to client',
      privateProjectLock: 'Tasks in a private project are always private — visible only to project members',
      createTask: 'Create task', saveFailed: 'Save failed',
    },
    taskCard: { private: 'Private', markDone: 'Mark as done', finish: 'Complete', reopen: 'Reopen', archive: 'Archive' },
    subtasks: {
      toggle: 'Subtasks', titleCol: 'Subtask', titlePlaceholder: 'Subtask name',
      col: 'Column', addColumn: 'Add column', removeColumn: 'Delete column', newColumn: 'New column',
      removeColumnConfirm: 'Delete the column “{label}”?',
      addRow: 'Add', removeRow: 'Delete', addPlaceholder: 'New subtask…', empty: 'No subtasks yet',
    },
    fields: {
      manage: 'Manage fields', addField: 'Add field', newField: 'Create a field',
      name: 'Field name', namePlaceholder: 'Field name', type: 'Field type',
      typeText: 'Text', typeNumber: 'Number', typeDate: 'Date', typeSelect: 'Select',
      options: 'Values', addValue: 'Add a value', addValueShort: 'Add',
      scopeThis: 'Add to this project', scopeAll: 'Add to all projects',
      globalBadge: 'Global', existing: 'Existing fields', empty: 'No fields yet',
      create: 'Create field', remove: 'Delete field', removeConfirm: 'Delete the field “{label}”?',
      pickValue: '— Select —',
    },
    comments: {
      title: 'Comments', empty: 'No comments yet',
      placeholder: 'Write a comment…', send: 'Send', closed: 'This task is completed — commenting is closed.',
    },
    export: {
      task: 'Task', project: 'Project', assignee: 'Assignee',
      status: 'Status', urgency: 'Urgency', hours: 'Hours', due: 'Due date',
    },
    timer: { start: 'Start timer', stop: 'Stop timer', running: 'Running now' },
    toast: {
      saved: 'Changes saved',
      taskCreated: 'Task created',
      saveFailed: "Couldn't save your changes. Check your internet connection and try again.",
      actionFailed: "That didn't go through. Give it another try in a moment.",
      taskCompleted: 'Task completed and moved to the archive',
      taskRestored: 'Task restored to the active list',
      taskReopened: 'Task reopened',
      assigned: 'Assigned to {name}',
      unassigned: 'Assignment removed',
      projectSaved: 'Project saved',
      projectArchived: 'Project moved to the archive',
      projectRestored: 'Project restored',
    },
    urgency: { low: 'Low', normal: 'Normal', high: 'High', critical: 'Critical' },
    status: { open: 'Open', in_progress: 'In Progress', done: 'Done' },
    projects: {
      title: 'Projects', newProject: 'New Project', editProject: 'Edit Project',
      empty: 'No projects yet.',
      name: 'Name', description: 'Description', color: 'Color', visibility: 'Visibility',
      shared: 'Shared (team sees this)', private: 'Private (only you)',
      sharedBadge: 'Shared', privateBadge: 'Private',
      taskCountOne: 'open task', taskCountMany: 'open tasks',
      noTasks: 'No tasks in this project', dragHint: 'Drag to reorder or move between projects',
      viewTasks: 'View tasks', archiveTitle: 'Archive project',
      archiveConfirm: 'Archive project "{name}"? It will no longer appear in the project list.',
      members: 'Project members', addMember: 'Add', remove: 'Remove',
      noMembers: 'No members yet', selectUser: '— Select user —',
      membersHint: 'Members can see the project and create tasks in it',
      saveFirst: 'Save the project first to add members',
      pricing: 'Pricing', pricingNone: 'No pricing', pricingFixed: 'Fixed price', pricingHourly: 'Per hour',
      ratePlaceholder: 'Hourly rate', totalPlaceholder: 'Total price',
      clients: 'Project clients', clientsHint: 'Assigned clients can see the project’s tasks and hours',
      noClients: 'No clients assigned', selectClient: '— Select client —', addClientBtn: 'Add',
    },
    archive: {
      title: 'Archive', sub: 'Archived projects — completed tasks live under each project’s "All tasks" filter',
      tasks: 'Tasks', projects: 'Projects',
      noTasks: 'No archived tasks.', noProjects: 'No archived projects.',
      archivedOn: 'Archived',
      restore: 'Restore', restoreConfirm: 'Restore "{title}" from the archive?',
    },
    teamPage: {
      title: 'Team', sub: 'Developers and shared projects in your workspace',
      developers: 'Developers', projects: 'Shared projects',
      noProjects: 'No shared projects', tasksCount: 'open tasks',
    },
    clients: {
      title: 'Clients', sub: 'External clients who can view tasks shared with them',
      addClient: 'Add Client', editClient: 'Edit Client',
      name: 'Name', username: 'Username', status: 'Status', projects: 'Projects',
      searchPh: 'Search by name or project…',
      active: 'Active', inactive: 'Inactive',
      activate: 'Activate', deactivate: 'Deactivate',
      empty: 'No external clients yet.',
      fullName: 'Full name', usernamePlaceholder: 'no spaces, used to log in',
      newPassword: 'New password (leave blank to keep)', passwordLabel: 'Password',
      passwordPlaceholder: 'min 8 characters',
      toggleConfirm: '{verb} {name}?',
    },
  },
}
